<div style="max-height: 80vh;">

  <div class="d-md-flex align-items-center border-top bg-white p-3">
    <form [formGroup]="ricercaform" class="input-group">
      <div class="input-group col-md-9 ">
        <div class="input-group-prepend">
          <label class="input-group-text" for="cerca">Cerca</label>
        </div>
        <input formControlName="cerca" type="text" name="cerca" class="form-control">
      </div>
      <div class="input-group col-md-3">
        <div class="input-group-prepend ">
          <label class="input-group-text" for="fine">Elementi</label>
        </div>
        <select class="custom-select" (change)="sizeChanged()" formControlName="size">
          <option value="1">1</option>
          <option value="10">10</option>
          <option value="25">25</option>
          <option selected value="50">50</option>
          <option value="100">100</option>
          <option value="200">200</option>
          <option value="500">500</option>
          <option value="1000">1000</option>
        </select>
      </div>
    </form>
    <div class="ml-auto mt-3 mt-md-0 d-flex align-items-center p-1">
      <button class="btn btn-outline-info rounded-pill" style="width: 100%;" (click)="Search()"
        type="button">Cerca</button>
    </div>
  </div>

  <div style="overflow-y: scroll; overflow-x: hidden; max-height: calc(80vh - 12rem);">
    <div class="row justify-content-center mt-3" *ngIf='Prodotti?.length'>
      <div class="col-lg-12" style="border-bottom: 1px solid lightgray;"
        *ngFor="let prodotto of Prodotti | slice: (page-1) * pageSize : (page-1) * pageSize + pageSize ">
        <div class="card">
          <div class="card-body text-center">
            <div class="row">
              <div class="col-md-5" style="align-items: center; display: flex;">
                <img src="{{apiPaths.getBaseAPI()}}/file/image/{{ prodotto.id_immagine }}" style="min-width: 100%;"
                  class=" border p-1">
              </div>
              <div class="col-md-7" style="text-align: left;">
                <h4 style="margin-left: 0.5rem; font-size: 1.125rem;" class="card-title mt-3 mb-0">{{ prodotto.prodotto
                  }}
                </h4>
                <small style="margin-left: 0.5rem; " class="text-muted">{{ prodotto.codice }}</small>
                <div class=" pt-3" *ngFor="let prezzo of prodotto.prezzi "
                  style="margin-left: 0.5rem; font-size: 1.125rem;">
                  {{prezzo.prezzo}} € VAT included
                </div>

                <div class="mt-3 pt-3" *ngFor="let Variazioni of prodotto.variazioniDistinta">
                  <ng-container *ngIf="Variazioni.partiList?.length">
                    <span class="">{{Variazioni?.categoriaObject?.categoria?.toUpperCase()}}:</span>
                    <ng-multiselect-dropdown style="margin-left: 0.5rem; " [settings]="MaterialeDropdownSettings"
                      [placeholder]="'Seleziona'" [(data)]="Variazioni.partiList" [(ngModel)]="Variazioni.parteObject">
                    </ng-multiselect-dropdown>
                    <!-- <div *ngFor="let parte of Variazioni?.partiList" class="" style="display: flex; justify-content: start;">
                                <span>  {{parte.nome}} </span>
                                <input type="checkbox" [(ngModel)]="parte.selected" (ngModelChange)="checkParte(Variazioni, parte, prodotto)" class="form-control" style="  height: 1rem; width: 1rem; margin-left: 2rem; ">
                              </div> -->
                  </ng-container>
                </div>




                <div class="col-lg-12">
                  <div class="row " *ngIf="prodotto.taglie?.length > 0">
                    <div class="col-md-4 py-3" *ngFor="let taglia of prodotto.taglie">
                      <div class="d-flex justify-content-center align-items-center"
                        style="border: 1px solid lightgray; padding: 0.50rem; border-bottom: none; background-color: rgba(0,0,0,0.1);">
                        <span class="font-16">{{taglia.taglia}}&nbsp;{{this.tipoProgetto?.id == "V" ? '( ' +
                          taglia.disponibili +' )' : ''}}</span>
                      </div>
                      <div class="d-flex justify-content-center align-items-center"
                        style="border: 1px solid lightgray; padding-inline: 0.25rem; padding-block: 10px; background-color: rgba(0,0,0,0.1);">
                        <div class="input-group col-12 ">
                          <div class="input-group-prepend ">
                            <label class="input-group-text" (click)='qtyminus(taglia)' for="fine">-</label>
                          </div>
                          <input type="number" [(ngModel)]="taglia.qty" class="form-control">
                          <div class="input-group-append ">
                            <label class="input-group-text" (click)='qtyplus(taglia)' for="fine">+</label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>

            <div class="d-flex justify-content-md-end">
              <div class="d-flex justify-content-md-center" *ngIf="!prodotto.taglie?.length">
                <div class="input-group col-12 ">
                  <div class="input-group-prepend ">
                    <label class="input-group-text" (click)='qtyminus(prodotto)' for="fine">-</label>
                  </div>
                  <input type="number" [(ngModel)]="prodotto.qty" class="form-control">
                  <div class="input-group-append ">
                    <label class="input-group-text" (click)='qtyplus(prodotto)' for="fine">+</label>
                  </div>
                </div>
              </div>
              <div (click)='Click(prodotto)' class=" bg-dark border-top" style="min-width: 250px;">
                <div class="col-12 text-light border-right border-bottom py-2">
                  <a href="javascript:void(0)" class="link font-16 text-light">
                    Add to bag
                  </a>
                </div>

              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>


  <div class="d-flex justify-content-center p-2 pt-3 border-top">
    <ngb-pagination (pageChange)="getPage($event)" id="paginationComponent" [maxSize]="10"
      [collectionSize]="collectionSize" [pageSize]="pageSize">
    </ngb-pagination>
  </div>





</div>